import '@fontsource/oswald'
import '@fontsource/oswald/400.css'
// import 'antd/dist/antd.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { lazy, Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import 'react-quill/dist/quill.snow.css'
import './assets/font/flaticon.css'
import LoaderBox from './Components/LoaderBox/LoaderBox'
import './globals'
import * as serviceWorker from './serviceWorker'
// import './Style/ant-overwrite.scss'
import './Style/styles.scss'

const App = lazy(() => import('./App'))

const container = document.getElementById('root')
const root = ReactDOM.createRoot(container)
root.render(
  <Suspense fallback={<LoaderBox loader />}>
    <App />
  </Suspense>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
